// src/features/rbac/hooks/useRoleAbilities.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchRoleAbilities, setRoleAbilities } from '../api/rbacApi';

export function useRoleAbilities(role_key: string | null) {
  const qc = useQueryClient();

  const list = useQuery<string[], Error>({
    queryKey : ['rbac','roleAbilities', role_key],
    queryFn  : () => fetchRoleAbilities(role_key!),
    enabled  : !!role_key,
  });

  const save = useMutation<void, Error, string[]>({
    mutationFn: (abilities) => setRoleAbilities(role_key!, abilities),
    onSuccess : () => qc.invalidateQueries({ queryKey: ['rbac','roleAbilities', role_key] }),
  });

  return { ...list, save };
}